import {Injectable} from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class InvalidAddressCacheService {
  private readonly STORAGE_KEY = "invalid_addresses";
  private readonly cache: Map<string, string> = new Map();

  constructor() {
    this.loadFromStorage();
  }

  private loadFromStorage(): void {
    const stored = localStorage.getItem(this.STORAGE_KEY);
    if (!stored) return;

    try {
      const entries = JSON.parse(stored);
      entries.forEach(([address, hash]: [string, string]) => {
        this.cache.set(address, hash);
      });
    } catch (e) {
      console.error("Failed to load invalid addresses from storage:", e);
      localStorage.removeItem(this.STORAGE_KEY);
    }
  }

  private saveToStorage(): void {
    const entries = Array.from(this.cache.entries());
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(entries));
  }

  private getAddressHash(project: any): string {
    const {street, city, zipcode, country} = project;
    return `${street}|${city}|${zipcode}|${country}`;
  }

  isAddressInvalid(project: any): boolean {
    const address = this.getAddressOfProject(project);
    if (!address) return false;

    const hash = this.getAddressHash(project);
    return this.cache.get(address) === hash;
  }

  markAddressAsInvalid(project: any): void {
    const address = this.getAddressOfProject(project);
    if (!address) return;

    const hash = this.getAddressHash(project);
    this.cache.set(address, hash);
    this.saveToStorage();
  }

  clearInvalidAddress(project: any): void {
    const address = this.getAddressOfProject(project);
    if (!address) return;

    this.cache.delete(address);
    this.saveToStorage();
  }

  private getAddressOfProject(project: any): string {
    if (!project) return "";

    const parts = [];
    if (project.street) parts.push(project.street);
    if (project.city) parts.push(project.city);
    if (project.zipcode) parts.push(project.zipcode);
    if (project.country) parts.push(project.country);

    return parts.join(", ");
  }
} 